module.exports = __webpack_public_path__ + "img/chat-whatsapp.2ede157c.png";